const clearAuthState = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("gatewaySession");
};

export const authHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("accessToken") || "";
  if (token) return { Authorization: `Bearer ${token}` };
  return {};
};

const hasGatewaySession = () => localStorage.getItem("gatewaySession") === "1";

const refreshGatewaySession = async () => {
  if (!hasGatewaySession()) return false;
  const response = await fetch("/api/v1/auth/refresh", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  return response.ok;
};

const redirectToLogin = () => {
  clearAuthState();
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

export const authFetch = async (input: RequestInfo | URL, init: RequestInit = {}) => {
  const response = await fetch(input, {
    ...init,
    credentials: "include",
    headers: {
      ...authHeaders(),
      ...(init.headers || {}),
    },
  });

  if (response.status !== 401) return response;

  const refreshed = await refreshGatewaySession().catch(() => false);
  if (!refreshed) {
    redirectToLogin();
    return response;
  }

  return fetch(input, {
    ...init,
    credentials: "include",
    headers: {
      ...authHeaders(),
      ...(init.headers || {}),
    },
  });
};
